import { IBlockDefinition, IBlockProps } from '@fox/blocks/contracts/block';
import { LOCATION_MAP_BLOCK_TYPE } from '@fox/blocks/contracts/block-types';
import { LocationProps } from '@fox/blocks/contracts/block-props/location';
import { FlexRowSpacedCentered } from '@fox/layout/src/flex';
import { useTheme } from 'styled-components';
import { EVENT_LOCATION_MAP_BLOCK_TYPE } from '../../../form-block-types';
import { getAttributeValues, transformLegacyProps } from '../../../utils';

export function LocationBlock({ props, type }: IBlockProps<LocationProps>) {
	const { imageUrl, formatted } = props;
	const theme = useTheme();
	const {
		attributes: { padding }
	} = transformLegacyProps(type, props);
	const { top: paddingTop, bottom: paddingBottom, right: paddingRight, left: paddingLeft } = getAttributeValues(padding);

	return (
		<div style={{ backgroundColor: theme.colors.white, textAlign: 'center' }}>
			<div style={{ width: '100%', paddingTop, paddingBottom, paddingLeft, paddingRight }}>
				{imageUrl ? (
					<FlexRowSpacedCentered>
						<img alt="" style={{ maxWidth: '100%', width: '100%' }} src={imageUrl} />
					</FlexRowSpacedCentered>
				) : (
					<></>
				)}

				<div style={{ textAlign: 'center' }}>{formatted}</div>
			</div>
		</div>
	);
}

export const LocationMapBlockRuntime: IBlockDefinition<LocationProps> = {
	type: LOCATION_MAP_BLOCK_TYPE,
	Component: LocationBlock
};

export const EventLocationMapBlockRuntime: IBlockDefinition<LocationProps> = {
	type: EVENT_LOCATION_MAP_BLOCK_TYPE,
	Component: LocationBlock
};
